import CheckCircle from "@mui/icons-material/CheckCircle";
import CircleOutlined from "@mui/icons-material/CircleOutlined";
import { StepIconProps } from "@mui/material";

export const StatusBarIcon = ({ active, completed }: StepIconProps) => {
  return completed || active ? <CheckCircle sx={{ fontSize: 40 }} /> : <CircleOutlined sx={{ fontSize: 40, color: "primary.main" }} />;
};